import { createTheme } from '@mui/material'
import { type TenantPaletteConfig } from '../../types'
import { palettePplLight } from './light'
import { palettePplDark } from './dark'

const lightPplPalette = createTheme({
  palette: palettePplLight,
}).palette

const darkPplPalette = createTheme({
  palette: palettePplDark,
}).palette

export const pplPalette: TenantPaletteConfig = {
  light: lightPplPalette,
  dark: darkPplPalette,
}
